import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../ui/AlertDialog';
import { useStudents } from '../../contexts/StudentsContext';
import type { Student } from '../../types/student';
import { describeFirebaseError } from '../../utils/firebase';
interface DeleteStudentDialogProps {
  student: Student | null;
  onClose: () => void;
}
export function DeleteStudentDialog({
  student,
  onClose
}: DeleteStudentDialogProps) {
  const {
    removeStudent
  } = useStudents();
  const [deleting, setDeleting] = useState(false);
  const handleDelete = async () => {
    if (!student) return;
    setDeleting(true);
    try {
      const result = await removeStudent(student);
      const label = student.fullNames.trim() || 'Untitled record';
      if (result === 'pending') {
        toast.warning('Deleted on this device', {
          description: `${label} will be removed from Firestore once online.`
        });
      } else {
        toast.success('Record deleted from Firestore', {
          description: label
        });
      }
      onClose();
    } catch (error) {
      toast.error('Could not delete the record', {
        description: describeFirebaseError(error)
      });
    } finally {
      setDeleting(false);
    }
  };
  return <AlertDialog open={Boolean(student)} onOpenChange={open => open ? undefined : onClose()} data-id="element-229" data-mp="358tiinehttd0">
      <AlertDialogContent className="glass-strong rounded-3xl" data-id="element-230" data-mp="30g0ek1qump1z">
        <AlertDialogHeader data-id="element-231" data-mp="2wfhmq7oyhizs">
          <AlertDialogTitle data-id="element-232" data-mp="2weoj3flan9lv">Delete this student record?</AlertDialogTitle>
          <AlertDialogDescription data-id="element-233" data-mp="2rgn5392q60h9">
            {student?.fullNames.trim() || 'This record'} will be permanently removed from Firestore, together with any
            uploaded photo. This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter data-id="element-234" data-mp="2hkaam8zcvilg">
          <AlertDialogCancel disabled={deleting} className="rounded-xl" data-id="element-235" data-mp="27uv05lokzf2d">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction onClick={event => {
          event.preventDefault();
          void handleDelete();
        }} disabled={deleting} className="rounded-xl bg-destructive text-white hover:opacity-90" data-id="element-236" data-mp="2cty4t50nfj9t">
            {deleting && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-237" data-mp="2qkkts5glxusp" />}
            {deleting ? 'Deleting…' : 'Delete record'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>;
}